export default __webpack_public_path__ + "static/media/schedule-white.d152f786.svg";